import React, { useState } from "react";
import { Form, Input, Button } from "antd";
import DashboardBreadcrumb from "../../components/layout/DashboardBreadcrumb";
import { Content } from "antd/lib/layout/layout";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../helpers/NotificationHelpers";
import ChangePasswordApi from "../../api/auth/ChangePasswordApi";

function ChangePassword() {
  const [submit, setSubmit] = useState(false);
  const [form] = Form.useForm();
  const proHeight = document.body.clientHeight;
  const [valuesChanged, setValuesChanged] = useState(false);

  function showErrorMessage(message) {
    if (message === "Current password is incorrect") {
      form.setFields([
        {
          name: "currentPassword",
          errors: ["Current password is incorrect"],
        },
      ]);
    } else if (message?.toLowerCase().includes("password")) {
      form.setFields([
        {
          name: "newPassword",
          errors: [message],
        },
      ]);
    } else {
      openNotificationError(
        "bottomRight",
        message || "Couldn't change password. Try again later."
      );
    }
  }

  function strongPassword(password) {
    let strength = false;
    const passwordArray = password.split("");
    let lowercase = false;
    let uppercase = false;
    let number = false;
    let length = false;
    // Validate lowercase letters
    const lowerCaseLetters = /[a-z]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(lowerCaseLetters)) {
        lowercase = true;
      }
    });
    // Validate capital letters
    const upperCaseLetters = /[A-Z]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(upperCaseLetters)) {
        uppercase = true;
      }
    });
    // Validate numbers
    const numbers = /[0-9]/g;
    passwordArray.forEach((pass) => {
      if (pass.match(numbers)) {
        number = true;
      }
    });
    // Validate length
    if (passwordArray.length >= 8) {
      length = true;
    }
    if (lowercase && uppercase && number && length) {
      strength = true;
    }

    return strength;
  }

  async function onFinish(values) {
    setSubmit(true);
    if (!strongPassword(values.newPassword)) {
      form.setFields([
        {
          name: "newPassword",
          errors: ["Enter a strong password!"],
        },
      ]);
    } else if (values.newPassword !== values.confirmPassword) {
      form.setFields([
        {
          name: "confirmPassword",
          errors: ["Password doesn't match!"],
        },
      ]);
    } else {
      const apiResponse = await ChangePasswordApi(
        values.currentPassword,
        values.newPassword,
        values.confirmPassword
      );
      console.log(apiResponse);
      if (apiResponse.error) {
        showErrorMessage(apiResponse.message);
      } else if (apiResponse.data?.username) {
        form.resetFields();
        openNotificationSuccess("bottomRight", apiResponse.message);
      } else {
        form.resetFields();
        openNotificationError(
          "bottomRight",
          `Password change Failed. Try again later}`
        );
      }
    }
    setSubmit(false);
    setValuesChanged(false);
  }

  const left = (
    <>
      <div className="pri-font text-lg">Change password</div>
    </>
  );

  return (
    <>
      <Content style={{ backgroundColor: "#fff" }}>
        <DashboardBreadcrumb left={left} />
        <div
          style={{
            height: proHeight - 122,
            overflow: "auto",
          }}
          className="custom-scroll p-6"
        >
          <div className="max-w-xl">
            <Form
              form={form}
              name="changePassword"
              onFinish={onFinish}
              scrollToFirstError
              layout="vertical"
              requiredMark={false}
              onValuesChange={() => {
                setValuesChanged(true);
              }}
            >
              <Form.Item
                name="currentPassword"
                label="Old Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter current password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>
              <Form.Item
                name="newPassword"
                label="New Password"
                rules={[
                  {
                    required: true,
                    message: "Please enter new password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item
                name="confirmPassword"
                label="Confirm Password"
                rules={[
                  {
                    required: true,
                    message: "Please re enter password!",
                  },
                ]}
              >
                <Input.Password />
              </Form.Item>

              <div className="mb-6 text-xs">
                Your password must be at least 8 characters long, contain at
                least one number, one uppercase letter and one lowercase letter.
              </div>
              <Form.Item>
                <Button
                  className="btn"
                  type="primary"
                  htmlType="submit"
                  disabled={submit || !valuesChanged}
                >
                  Update Password
                </Button>
              </Form.Item>
            </Form>
          </div>
        </div>
      </Content>
    </>
  );
}

export default ChangePassword;
